import React from 'react';
import { Button } from 'reactstrap';

import './ArticleActionBar.css'

const ArticleActionBar = (props) => {
    const { likes, expandArticle, likeArticle, edit, articleId, isLiked, isEditor, buttonStyle, isExpanded } = props;
    return (
        <div className="article-footer">
            <Button onClick={expandArticle} style={buttonStyle && buttonStyle.button} >{isExpanded ? 'Läs mindre' : 'Läs mer'}</Button>
            {isEditor && <div className="edit-card">
                <i onClick={edit} className={`fa fa-edit edit-button`} />
            </div>}
            <div className="like-card">
                <i onClick={likeArticle} className={`fa fa-thumbs-up ${!isLiked ? 'not-liked' : 'like-button'} `} />
                <span className="like-count">{likes}</span>
            </div>
        </div>
    )
}
export default ArticleActionBar;